<template>
  <div class="container" ref="container">
    <div class="has-text-centered my-4">
      <h1 class="title">{{ title }}</h1>
    </div>

    <component v-bind:is="currentComponent" />
  </div>
</template>

<script>
import Location from "./Location";
import About from "./About";
import BidSystem from "./BidSystem";
import Employee from "./Employee";
import Toa from "./Toa";
import Tta from "./Tta";
import CustomerService from "./CustomerService";

export default {
  components: {
    Location,
    About,
    BidSystem,
    CustomerService,
    Employee,
    Toa,
    Tta
  },

  data() {
    return {
      isHidden: false
    };
  },

  computed: {
    title: function() {
      let route = this.$route.params.page;

      return this.getCompVal(route, true);
    },
    currentComponent: function() {
      let route = this.$route.params.page;
      return this.getCompVal(route);
    }
  },

  methods: {
    getCompVal: function(route, getTitle = false) {
      let comp, title;

      if (route == "lokasjoner") {
        comp = "CustomerService";
        title = "";
      } else if (route == "om-oss") {
        comp = "CustomerService";
        title = "";
      } else if (route == "kundeservice") {
        comp = "CustomerService";
        title = "";
      } else if (route == "ansatte") {
        comp = "Employee";
        title = "Ansatte i Stadssalg";
      } else if (route == "budsystemet") {
        comp = "BidSystem";
        title = "Budsystem og vilkår";
      } else if (route == "personvern") {
        comp = "Toa";
        title = "Personvernserklæring";
      } else if (route == "aapenhetsloven") {
        comp = "Tta";
        title = "Åpenhetsloven";
      } else {
        comp = "Location";
        title = "Våre infosider";
      }

      if (getTitle) {
        return title;
      } else {
        return comp;
      }
    }
  }
};
</script>

<style lang="scss">
.menuToggle {
  display: none;
}

@media screen and (max-width: $desktop) {
  .menuToggle {
    display: block;
  }
  .hideMenu {
    display: none;
  }
}

div.info-menu {
  margin-top: 2em !important;

  @media screen and (max-width: $desktop) {
    margin-left: 0;
    margin-right: 0;
  }

  div.column {
    a {
      @media screen and (max-width: $desktop) {
        font-size: 0;
      }
    }

    @media screen and (max-width: $desktop) {
      display: inline-flex;
    }
  }

  .column {
    a {
      color: #333;
      font-weight: 200;

      &:hover {
        color: #000;
      }
    }
  }
}
</style>
